import VueRouter from "vue-router";
import routes from "./routes";
import Vue from "vue";
import VueMeta from 'vue-meta';
import vueHeadful from 'vue-headful';

const router = new VueRouter({
    routes,
    linkActiveClass: "active",
    mode: 'history'
});

Vue.use(VueRouter);
Vue.use(VueMeta);
Vue.component('vue-headful', vueHeadful);

export default router;
